/* eslint-disable */

(function( $, window, document, undefinded ) {

    class BRScrollTo {

        constructor( el, options = {} ) {
            this.el = el;

            this.options = $.extend({}, {
                speed : 700,
                scrollElement: 'html, body',
                target : (() => {
                    let t = null;

                    if( this.el.hasAttribute( 'data-target' ) ) {
                        t = this.el.getAttribute( 'data-target' );
                    } else if( $(this.el).is('a') ) {
                        t = this.el.href;
                    }

                    return t;
                })()
            }, options);

            this._initClickEvent();
        }

        getTargetElement() {
            return document.querySelector(this.options.target);
        }

        hasTargetElement() {
            return this.getTargetElement() instanceof HTMLElement;
        }

        _initClickEvent() {
            $(this.el).on('click', e => {
                e.preventDefault();
                e.stopImmediatePropagation();

                if( this.hasTargetElement() ) {
                    const top = $(this.getTargetElement()).offset().top;

                    $('html,body').animate({
                        scrollTop: top
                    }, this.options.speed, 'swing' );

                }
            });
        }

    }

    $.fn.brScrollTo = function( options ) {
        this.each(function() {
            new BRScrollTo( this, options );
        });
    };

    $(document).ready(function() {
        $('[data-br-scroll-to]').brScrollTo();
    });

})( jQuery, window, document );